import { render, staticRenderFns } from "./PayoutTransDetails.vue?vue&type=template&id=b6d97b22&scoped=true"
import script from "./PayoutTransDetails.vue?vue&type=script&lang=js"
export * from "./PayoutTransDetails.vue?vue&type=script&lang=js"
import style0 from "./PayoutTransDetails.vue?vue&type=style&index=0&id=b6d97b22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d97b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d97b22')) {
      api.createRecord('b6d97b22', component.options)
    } else {
      api.reload('b6d97b22', component.options)
    }
    module.hot.accept("./PayoutTransDetails.vue?vue&type=template&id=b6d97b22&scoped=true", function () {
      api.rerender('b6d97b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data-agent/components/PayoutTransDetails.vue"
export default component.exports